import { LuggageEnum } from "./types";

export const initialLuggageFields = {
  [LuggageEnum.carryOnLuggage]: 0,
  [LuggageEnum.checkedLuggage]: 0,
  [LuggageEnum.oversizeLuggage]: 0,
};
